import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback } from 'react';

import {
  GetPatientProfileFooterAppointmentDocument,
  SendCongestionNotificationDocument,
} from '~/graphql/generated/graphql';
import { notificationCongestionModalState } from '~/state/partials/patient_profile_drawer/atoms';

export const useSendCongestionNotification = () => {
  const { isOpen, appointmentId } = useAtomValue(notificationCongestionModalState);
  const resetNotificationCongestionModalState = useResetAtom(notificationCongestionModalState);

  const [sendNotification, { loading, error }] = useMutation(SendCongestionNotificationDocument, {
    refetchQueries: [
      { query: GetPatientProfileFooterAppointmentDocument, variables: { appointmentId } },
    ],
  });

  const handleSend = useCallback(async () => {
    if (!appointmentId || !isOpen) return;

    try {
      await sendNotification({
        variables: {
          input: {
            appointmentId,
          },
        },
      });

      resetNotificationCongestionModalState();
    } catch {
      // 何もしない
    }
  }, [appointmentId, isOpen, sendNotification, resetNotificationCongestionModalState]);

  return { sending: loading, error, handleSend };
};
